import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/plans.json';
import ar from './i18n/ar/plans.json';

registerFeatureI18n('adminPlans', { en, ar });

export { PlansPage } from './PlansPage';
